import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class PublicUrlService {
  private publicPatterns = [
    environment.keycloakHost,
    '/uuid',
    '/getUserMenus',
  ];



  isPublic(url: string): boolean {


    return this.publicPatterns.some(pattern => url.includes(pattern));
  }
}
